import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SelectOption } from "../../shared/interfaces/select-option";
import { SecurityTypeService } from "../services/security-type.service";

export const securityTypesResolver: ResolveFn<SelectOption[]> = () => {
    const service = inject(SecurityTypeService);
    return service.getSecurityTypes();
};